import React from "react";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import IntegrationsBar from "./IntegrationsBar";
import SolutionChecklist, { SolutionChecklistItem } from "./SolutionChecklist";
import teamImage from "../images/acadamies/Group-image-polaris-athlete.webp";
import revPrepBanner from "../images/landing-page/revolution-prep-banner.png";
import "../styles/solutions-page.css";
import "../styles/landing-page.css";

const ORGANIZATION_INTRO =
    "Polaris Athlete Hub is built for organizations committed to student-athlete success. From college readiness and NIL education to communication, progress tracking, and expert-led learning, the platform gives organizations the tools and resources to engage, guide, and support student-athletes at every stage of their journey.";

const ORGANIZATION_CARD_INTRO =
    "Polaris Athlete Hub gives organizations one centralized platform to manage, engage, and support student-athletes. With built-in roster management, NIL education, college readiness, communication, and progress tracking, teams can guide every athlete's journey from one seamless solution.";

const ORGANIZATION_FEATURES: SolutionChecklistItem[] = [
    {
        title: "Fully Branded Platform",
        description:
            "Create a platform that reflects your school or organization. Upload your logo and branding so student-athletes engage with resources in a space that feels like your program.",
    },
    {
        title: "NIL Education For Your Community",
        description:
            "Provide student-athletes, coaches, and staff with structured NIL education, including advanced programming like the NIL MBA course led by industry expert, Bill Carter.",
    },
    {
        title: "Team & Roster Management",
        description:
            "Easily manage teams, organize rosters, and communicate with athletes in one centralized platform.",
    },
    {
        title: "Curated Events & Programming",
        description:
            "Polaris Athlete Hub provides a dynamic calendar of expert-led events. Access workshops, webinars, and training sessions on college counseling, NIL education, and athlete development, all curated to support staff in guiding student-athletes effectively.",
    },
    {
        title: "Google Integration",
        description:
            "Sync your Google Calendar and Google Drive with Polaris Athlete Hub. Seamless SSO login via Google, making it easy for athletes, coaches, and staff to access everything they need without extra credentials.",
    },
    {
        title: "CRM Management",
        description:
            "Polaris Athlete Hub offers built-in CRM tools to help IECs, academies, and athletic organizations manage their roster and caseload efficiently. Track hours, document notes, log Google meetings and links, and manage each athlete one session at a time—making it easier to stay organized and support billing and reporting.",
    },
    {
        title: "Stripe Integration",
        description:
            "All billing and payments are handled securely through Stripe, one of the most trusted payment platforms.",
    },
];

export default function OrganizationsPage() {
    return (
        <main className="solution-page">
            <PublicHeader />

            <section className="solution-hero">
                <h1 className="solution-hero-heading">For Organizations</h1>
                <p className="solution-hero-intro">{ORGANIZATION_INTRO}</p>
            </section>

            <section className="solution-features-section">
                <div className="solution-features-card">
                    <div className="solution-features-top">
                        <div className="solution-features-intro-col">
                            <p className="solution-features-label">
                                <span className="solution-features-diamond" aria-hidden="true">✦</span> Our features
                            </p>
                            <h2 className="solution-features-heading">
                                Supporting Organizations Through The Student-Athlete Journey
                            </h2>
                            <p className="solution-features-intro">{ORGANIZATION_CARD_INTRO}</p>
                        </div>
                        <figure className="solution-features-media">
                            <img
                                src={teamImage}
                                alt="Polaris Athlete student-athletes"
                                className="solution-features-photo"
                            />
                            <figcaption className="solution-features-caption">
                                Polaris Athlete Mentor, Ellie Rodriguez, Women&apos;s Rowing
                            </figcaption>
                        </figure>
                    </div>
                    <SolutionChecklist items={ORGANIZATION_FEATURES} />
                </div>
            </section>

            <IntegrationsBar />

            <section className="landing-revprep">
                <div className="landing-revprep-inner">
                    <div className="landing-revprep-banner">
                        <img
                            src={revPrepBanner}
                            alt="Revolution Prep"
                            className="landing-revprep-banner-logo"
                        />
                        <div className="landing-revprep-banner-content">
                            <h3 className="landing-revprep-banner-heading">Free Test Prep &amp; Tutoring</h3>
                            <p className="landing-revprep-banner-desc">
                                All student-athletes receive 2 hours ($200+ value) of complimentary test prep
                                or tutoring through our partner, RevPrep, helping them strengthen academic
                                skills and stay on track for college success.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <PublicFooter />
        </main>
    );
}
